import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { authAPI } from '../services/api';

export default function Register() {
  const navigate = useNavigate();
  const [mode, setMode] = useState(null); // null | 'sender' | 'agent'
  const [step, setStep] = useState(1);
  const [form, setForm] = useState({
    // Common
    email: '', password: '', full_name: '', phone: '', country: 'US',
    // Agent specific
    agent_country: 'CU', province: '', city: '', coverage_zone: '',
    delivery_methods: ['cash', 'transfermovil'],
    max_tx_per_day: 10, daily_capacity_usd: '', telegram_username: '',
    motivation: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const toggleDelivery = (m) => {
    const curr = form.delivery_methods;
    set('delivery_methods', curr.includes(m) ? curr.filter(x => x !== m) : [...curr, m]);
  };

  const handleRegister = async () => {
    if (!form.email || !form.password || !form.full_name) {
      setError('Completa todos los campos requeridos'); return;
    }
    setLoading(true); setError('');
    try {
      await authAPI.register({
        email: form.email, password: form.password,
        full_name: form.full_name, phone: form.phone, country: form.country,
      });

      // If agent, also submit agent application after login
      if (mode === 'agent') {
        // Login to get token
        const loginRes = await authAPI.login(form.email, form.password);
        const token = loginRes.data.access_token;
        localStorage.setItem('token', token);

        // Submit agent application
        const api = (await import('../services/api')).default;
        await api.post('/api/v1/agents/register', {
          full_name: form.full_name,
          email: form.email,
          phone: form.phone,
          country: form.agent_country,
          province: form.province,
          city: form.city,
          coverage_zone: form.coverage_zone,
          delivery_methods: form.delivery_methods,
          max_tx_per_day: parseInt(form.max_tx_per_day),
          daily_capacity_usd: form.daily_capacity_usd ? parseFloat(form.daily_capacity_usd) : null,
          telegram_username: form.telegram_username,
          motivation: form.motivation,
        });

        navigate('/app/agent/pending');
      } else {
        navigate('/login', { state: { registered: true } });
      }
    } catch (e) {
      const detail = e.response?.data?.detail;
      setError(Array.isArray(detail) ? detail.map(d => d.msg).join(', ') : (detail || 'Error al registrarse'));
    } finally { setLoading(false); }
  };

  const inputStyle = { width: '100%', padding: '11px 14px', border: '1px solid #e2dbd0', borderRadius: 8, fontSize: 14, outline: 'none', boxSizing: 'border-box', background: '#faf8f5' };
  const labelStyle = { display: 'block', fontSize: 10.5, fontWeight: 700, letterSpacing: '.07em', textTransform: 'uppercase', color: '#7a7060', marginBottom: 6 };

  // Mode selection
  if (!mode) return (
    <div style={{ minHeight: '100vh', background: 'radial-gradient(900px 480px at 75% -10%, rgba(75,223,142,.14), transparent 60%), #080c0a', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ maxWidth: 480, width: '100%' }}>
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <div style={{ width: 52, height: 52, borderRadius: 12, background: '#4bdf8e', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Outfit', fontSize: 28, fontWeight: 800, color: '#06281a', margin: '0 auto 16px' }}>G</div>
          <h1 style={{ fontFamily: 'Outfit, sans-serif', fontSize: 28, color: '#fff', margin: '0 0 8px' }}>Únete a Guarapo</h1>
          <p style={{ color: 'rgba(255,255,255,.5)', fontSize: 14 }}>¿Cómo quieres participar?</p>
        </div>

        <div style={{ display: 'grid', gap: 14 }}>
          <button onClick={() => setMode('sender')} style={{ background: '#fff', border: 'none', borderRadius: 16, padding: 24, cursor: 'pointer', textAlign: 'left' }}
            onMouseOver={e => e.currentTarget.style.background = '#f9f6f1'}
            onMouseOut={e => e.currentTarget.style.background = '#fff'}>
            <div style={{ fontSize: 32, marginBottom: 10 }}>📤</div>
            <div style={{ fontFamily: 'Outfit, sans-serif', fontSize: 18, marginBottom: 6 }}>Quiero enviar servicios</div>
            <div style={{ fontSize: 13, color: '#7a7060', lineHeight: 1.5 }}>
              Coordina envíos de dinero, recargas y entregas a Cuba desde cualquier parte del mundo.
            </div>
            <div style={{ marginTop: 12, fontSize: 12, color: '#4bdf8e', fontWeight: 600 }}>Registro gratuito →</div>
          </button>

          <button onClick={() => setMode('agent')} style={{ background: '#fff', border: 'none', borderRadius: 16, padding: 24, cursor: 'pointer', textAlign: 'left' }}
            onMouseOver={e => e.currentTarget.style.background = '#f9f6f1'}
            onMouseOut={e => e.currentTarget.style.background = '#fff'}>
            <div style={{ fontSize: 32, marginBottom: 10 }}>🤝</div>
            <div style={{ fontFamily: 'Outfit, sans-serif', fontSize: 18, marginBottom: 6 }}>Quiero ser agente</div>
            <div style={{ fontSize: 13, color: '#7a7060', lineHeight: 1.5 }}>
              Conviértete en coordinador local. Recibe órdenes, gestiona entregas y gana dinero en tu zona.
            </div>
            <div style={{ marginTop: 12, fontSize: 12, color: '#4bdf8e', fontWeight: 600 }}>Aplicar como agente →</div>
          </button>
        </div>

        <div style={{ textAlign: 'center', marginTop: 24 }}>
          <Link to="/login" style={{ color: 'rgba(255,255,255,.4)', fontSize: 13, textDecoration: 'none' }}>
            ¿Ya tienes cuenta? <span style={{ color: '#4bdf8e' }}>Inicia sesión</span>
          </Link>
        </div>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', background: 'radial-gradient(900px 480px at 75% -10%, rgba(75,223,142,.14), transparent 60%), #080c0a', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ maxWidth: 520, width: '100%' }}>
        <button onClick={() => { setMode(null); setStep(1); }} style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,.4)', fontSize: 13, cursor: 'pointer', marginBottom: 24 }}>
          ← Volver
        </button>

        <div style={{ marginBottom: 28 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
            <div style={{ fontSize: 28 }}>{mode === 'agent' ? '🤝' : '📤'}</div>
            <h1 style={{ fontFamily: 'Outfit, sans-serif', fontSize: 24, color: '#fff', margin: 0 }}>
              {mode === 'agent' ? 'Aplicar como agente' : 'Crear cuenta'}
            </h1>
          </div>
          {mode === 'agent' && (
            <p style={{ color: 'rgba(255,255,255,.4)', fontSize: 13, margin: 0 }}>
              Tu solicitud será revisada en 24-48 horas
            </p>
          )}
        </div>

        {error && (
          <div style={{ background: '#faeef4', border: '1px solid #f4b8c8', borderRadius: 8, padding: '10px 14px', marginBottom: 16, fontSize: 13, color: '#9b2c5e' }}>
            ⚠ {error}
          </div>
        )}

        {/* Step indicators for agent */}
        {mode === 'agent' && (
          <div style={{ display: 'flex', gap: 8, marginBottom: 24 }}>
            {['Cuenta', 'Zona', 'Info'].map((s, i) => (
              <div key={i} style={{ flex: 1, height: 4, borderRadius: 2, background: step > i ? '#4bdf8e' : 'rgba(255,255,255,.15)' }} />
            ))}
          </div>
        )}

        <div style={{ background: '#fff', borderRadius: 16, padding: 24 }}>

          {/* Step 1: Account info (both modes) */}
          {step === 1 && (
            <div>
              <div style={{ fontFamily: 'Outfit, sans-serif', fontSize: 16, marginBottom: 18, color: '#0f0d0b' }}>
                Información de cuenta
              </div>
              {[
                { key: 'full_name', label: 'NOMBRE COMPLETO', placeholder: 'Carlos Martínez', type: 'text' },
                { key: 'email', label: 'EMAIL', placeholder: 'tu@email.com', type: 'email' },
                { key: 'password', label: 'CONTRASEÑA', placeholder: 'Mínimo 8 caracteres', type: 'password' },
                { key: 'phone', label: 'TELÉFONO (donde resides)', placeholder: '+1 305 555 0001', type: 'tel' },
              ].map(f => (
                <div key={f.key} style={{ marginBottom: 14 }}>
                  <label style={labelStyle}>{f.label}</label>
                  <input style={inputStyle} type={f.type} placeholder={f.placeholder}
                    value={form[f.key]} onChange={e => set(f.key, e.target.value)}
                    autoCapitalize={f.key === 'email' ? 'none' : 'words'} />
                </div>
              ))}

              <div style={{ marginBottom: 14 }}>
                <label style={labelStyle}>PAÍS DONDE RESIDES</label>
                <select style={inputStyle} value={form.country} onChange={e => set('country', e.target.value)}>
                  {[['US', '🇺🇸 Estados Unidos'], ['IT', '🇮🇹 Italia'], ['ES', '🇪🇸 España'], ['MX', '🇲🇽 México'], ['CU', '🇨🇺 Cuba'], ['DE', '🇩🇪 Alemania'], ['FR', '🇫🇷 Francia'], ['CA', '🇨🇦 Canadá'], ['OTHER', '🌍 Otro']].map(([v, l]) => (
                    <option key={v} value={v}>{l}</option>
                  ))}
                </select>
              </div>

              <button onClick={() => mode === 'agent' ? setStep(2) : handleRegister()} disabled={loading}
                style={{ width: '100%', padding: '13px', borderRadius: 10, border: 'none', background: loading ? '#e2dbd0' : '#4bdf8e', color: '#06281a', fontSize: 15, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer' }}>
                {loading ? 'Creando cuenta...' : mode === 'agent' ? 'Continuar →' : 'Crear cuenta →'}
              </button>
            </div>
          )}

          {/* Step 2: Agent zone (agent only) */}
          {step === 2 && mode === 'agent' && (
            <div>
              <div style={{ fontFamily: 'Outfit, sans-serif', fontSize: 16, marginBottom: 18 }}>Zona de operación</div>

              <div style={{ marginBottom: 14 }}>
                <label style={labelStyle}>PAÍS DONDE OPERAS</label>
                <select style={inputStyle} value={form.agent_country} onChange={e => set('agent_country', e.target.value)}>
                  {[['CU', '🇨🇺 Cuba'], ['US', '🇺🇸 Estados Unidos'], ['IT', '🇮🇹 Italia'], ['ES', '🇪🇸 España'], ['MX', '🇲🇽 México'], ['OTHER', '🌍 Otro']].map(([v, l]) => (
                    <option key={v} value={v}>{l}</option>
                  ))}
                </select>
              </div>

              {[
                { key: 'province', label: 'PROVINCIA / ESTADO', placeholder: 'La Habana' },
                { key: 'city', label: 'CIUDAD / MUNICIPIO', placeholder: 'Centro Habana' },
              ].map(f => (
                <div key={f.key} style={{ marginBottom: 14 }}>
                  <label style={labelStyle}>{f.label}</label>
                  <input style={inputStyle} placeholder={f.placeholder}
                    value={form[f.key]} onChange={e => set(f.key, e.target.value)} />
                </div>
              ))}

              <div style={{ marginBottom: 14 }}>
                <label style={labelStyle}>ZONA DE COBERTURA (descripción libre)</label>
                <textarea style={{ ...inputStyle, minHeight: 80, resize: 'vertical' }}
                  placeholder="Cubro municipios: Centro Habana, Habana Vieja, Plaza de la Revolución..."
                  value={form.coverage_zone} onChange={e => set('coverage_zone', e.target.value)} />
              </div>

              <div style={{ marginBottom: 20 }}>
                <label style={labelStyle}>MÉTODOS DE ENTREGA QUE OFRECES</label>
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                  {[
                    { v: 'cash', l: '💵 Efectivo' },
                    { v: 'transfermovil', l: '📱 Transfermóvil' },
                    { v: 'cubacel', l: '📶 Cubacel' },
                  ].map(m => (
                    <button key={m.v} type="button" onClick={() => toggleDelivery(m.v)}
                      style={{ padding: '8px 14px', borderRadius: 20, border: `2px solid ${form.delivery_methods.includes(m.v) ? '#4bdf8e' : '#e2dbd0'}`, background: form.delivery_methods.includes(m.v) ? '#fdf4f0' : '#fff', fontSize: 13, cursor: 'pointer', fontWeight: 600, color: form.delivery_methods.includes(m.v) ? '#4bdf8e' : '#7a7060' }}>
                      {m.l}
                    </button>
                  ))}
                </div>
              </div>

              <div style={{ display: 'flex', gap: 10 }}>
                <button onClick={() => setStep(1)} style={{ flex: 1, padding: '12px', borderRadius: 10, border: '1px solid #e2dbd0', background: '#fff', fontSize: 14, cursor: 'pointer' }}>
                  ← Atrás
                </button>
                <button onClick={() => setStep(3)} style={{ flex: 2, padding: '12px', borderRadius: 10, border: 'none', background: '#4bdf8e', color: '#fff', fontSize: 14, fontWeight: 700, cursor: 'pointer' }}>
                  Continuar →
                </button>
              </div>
            </div>
          )}

          {/* Step 3: Agent capacity (agent only) */}
          {step === 3 && mode === 'agent' && (
            <div>
              <div style={{ fontFamily: 'Outfit, sans-serif', fontSize: 16, marginBottom: 18 }}>Capacidad y contacto</div>

              {[
                { key: 'max_tx_per_day', label: 'MÁXIMO DE ENTREGAS POR DÍA', placeholder: '10', type: 'number' },
                { key: 'daily_capacity_usd', label: 'CAPACIDAD DIARIA (USD)', placeholder: '500', type: 'number' },
                { key: 'telegram_username', label: 'USUARIO TELEGRAM (opcional)', placeholder: '@tu_usuario', type: 'text' },
              ].map(f => (
                <div key={f.key} style={{ marginBottom: 14 }}>
                  <label style={labelStyle}>{f.label}</label>
                  <input style={inputStyle} type={f.type} placeholder={f.placeholder}
                    value={form[f.key]} onChange={e => set(f.key, e.target.value)} />
                </div>
              ))}

              <div style={{ marginBottom: 20 }}>
                <label style={labelStyle}>¿POR QUÉ QUIERES SER AGENTE? (opcional)</label>
                <textarea style={{ ...inputStyle, minHeight: 80, resize: 'vertical' }}
                  placeholder="Tengo experiencia manejando remesas, conozco bien La Habana..."
                  value={form.motivation} onChange={e => set('motivation', e.target.value)} />
              </div>

              <div style={{ background: '#eaf1fb', borderRadius: 8, padding: '12px 14px', marginBottom: 20, fontSize: 12, color: '#1a4e8c' }}>
                🔒 Tu solicitud será revisada por nuestro equipo. Recibirás una respuesta en 24-48 horas.
              </div>

              <div style={{ display: 'flex', gap: 10 }}>
                <button onClick={() => setStep(2)} style={{ flex: 1, padding: '12px', borderRadius: 10, border: '1px solid #e2dbd0', background: '#fff', fontSize: 14, cursor: 'pointer' }}>
                  ← Atrás
                </button>
                <button onClick={handleRegister} disabled={loading}
                  style={{ flex: 2, padding: '12px', borderRadius: 10, border: 'none', background: loading ? '#e2dbd0' : '#4bdf8e', color: '#fff', fontSize: 14, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer' }}>
                  {loading ? 'Enviando...' : 'Enviar solicitud →'}
                </button>
              </div>
            </div>
          )}
        </div>

        <div style={{ textAlign: 'center', marginTop: 20 }}>
          <Link to="/login" style={{ color: 'rgba(255,255,255,.4)', fontSize: 13, textDecoration: 'none' }}>
            ¿Ya tienes cuenta? <span style={{ color: '#4bdf8e' }}>Inicia sesión</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
